/**
 * Where an inserted data reference lands in a text field.
 *
 * Its own module because it is the only logic in the insert affordance worth testing directly,
 * and a non-component export in a component file breaks fast refresh (this repo lints at
 * --max-warnings 0, which is the right call: the warning is about a real behaviour).
 */

/** Insert `token` into `value` at [start,end), returning the new value and the caret after it.
 *
 *  `delimiters` names the characters a field splits its entries on (`,` for the args field).
 *  Padding before one of them is not prose spacing, it is whitespace inside the entry, so
 *  none is added there. */
export function insertAtCaret(
  value: string, token: string, start: number, end: number,
  opts: { delimiters?: string } = {},
): { value: string; caret: number } {
  const head = value.slice(0, start)
  const tail = value.slice(end)
  // A reference butted against a word reads as part of it, and the model is being handed
  // prose — so pad only where padding is missing, never doubling an existing space.
  const needsLeading = head.length > 0 && !/\s$/.test(head)
  const beforeDelimiter = !!opts.delimiters && tail.length > 0 && opts.delimiters.includes(tail[0])
  const needsTrailing = tail.length > 0 && !/^\s/.test(tail) && !beforeDelimiter
  const insert = `${needsLeading ? ' ' : ''}${token}${needsTrailing ? ' ' : ''}`
  return { value: head + insert + tail, caret: (head + insert).length }
}
